<template>
  <div class="activity-operator" :style="btnConfig.style">
    <div v-if="isNormal" class="limit-text" :style="btnConfig.limitStyle">
      {{ limitText }}
    </div>
    <div v-if="showBtnStep" class="visual">
      <div class="sub" :style="{ width: '0.48rem' }">
        <hot-spot :right="0" @btnClick="catchMinusTap" />
        <maple-icon size="0.32rem" name="jianhao" color="#FE2A42" />
      </div>
      <div class="num" @click.stop="keyboardTap">
        {{ count }}
      </div>
      <div class="add" :style="{ width: '0.48rem' }">
        <hot-spot :left="0" @btnClick="catchPlusTap" />
        <maple-icon
          size="0.32rem"
          name="jiahao"
          :color="count < availableAmount ? '#FE2A42' : '#BFBFBF'"
        />
      </div>
    </div>
    <hot-spot v-if="!showBtnStep" @btnClick="hotSpotClick" />
    <div v-if="!showBtnStep" class="btn-text">{{ btnConfig.text }}</div>
  </div>
</template>

<script>
import HotSpot from './hotSpot'
export default {
  name: 'NewAcitivityComp',
  components: {
    HotSpot
  },
  props: {
    activityInfo: {
      type: Object,
      default: () => {}
    },
    hasSetRemind: {
      type: Boolean,
      default: false
    },
    count: {
      type: Number,
      default: 0
    },
    availableAmount: {
      type: Number,
      default: 0
    },
    isPromote: {
      type: Boolean,
      default: false
    },
    limitText: {
      type: String,
      default: ''
    }
  },
  computed: {
    btnConfig() {
      let style = {}
      let text = ''
      let limitStyle = {}
      if (this.isNormal) {
        // 秒杀进行中或促销
        if (this.count > 0) {
          style = {
            backgroundColor: '#f5f5f5',
            color: '#fff'
          }
          limitStyle = {
            color: '#999'
          }
        } else {
          text = '立即抢购'
          style = {
            backgroundImage: `linear-gradient(90deg, #ff5454, #ff5423)`,
            color: '#fff'
          }
          limitStyle = {
            color: '#FFD9CF'
          }
        }
      } else if (
        this.activityInfo.status === 0 ||
        this.activityInfo.status === 3
      ) {
        // 秒杀未开始（即将开、明天开始）
        if (this.hasSetRemind) {
          text = '已设置'
          style = {
            backgroundColor: '#fff',
            color: '#ff9d21',
            border: '1px solid #ff9d21'
          }
        } else {
          text = '提醒我'
          style = {
            backgroundColor: '#ff9d21',
            color: '#fff'
          }
        }
      } else {
        // 秒杀已结束
        text = '已结束'
        style = {
          backgroundColor: '#bfbfbf',
          color: '#fff'
        }
      }
      return {
        text,
        style,
        limitStyle
      }
    },
    isNormal() {
      // 秒杀进行中或是促销品
      return this.isPromote || this.activityInfo.status === 1
    },
    showBtnStep() {
      return this.count && this.isNormal
    }
  },
  methods: {
    hotSpotClick() {
      if (this.isNormal) {
        this.$emit('add')
      } else if (
        this.activityInfo.status === 0 ||
        this.activityInfo.status === 3
      ) {
        this.$emit('seckillRemind')
      }
    },
    catchMinusTap() {
      this.$emit('sub')
    },
    catchPlusTap() {
      this.$emit('add')
    },
    keyboardTap() {
      this.$emit('keyboard')
    }
  }
}
</script>

<style lang="scss" scoped>
.activity-operator {
  display: flex;

  position: relative;

  width: 1.6rem;
  height: 0.8rem;

  border-radius: 0.16rem;

  flex-direction: column;
  justify-content: center;
  align-items: center;
  .limit-text {
    font-size: 0.2rem;
    line-height: 0.28rem;
  }
  .btn-text {
    font-size: 0.28rem;
    line-height: 0.4rem;
  }
}

.visual {
  height: 0.48rem;

  flex: none;
  @include flex(row, flex-start, center, nowrap);

  .sub,
  .num,
  .add {
    position: relative;

    height: 0.48rem;

    text-align: center;
    @include flex-column-center;
  }

  .num {
    width: 0.64rem;

    font-size: 0.26rem;
    font-weight: bold;
    color: #262626;
    &:after {
      display: block;

      position: absolute;
      top: -0.16rem;
      right: 0;
      bottom: -0.16rem;
      left: 0;

      content: '';
    }
  }

  .sub,
  .add {
    width: 0.48rem; // 长32px(.64rem) 正常24px(.48rem) !! 待对接
  }
}
</style>
